export default __webpack_public_path__ + "d527457529b83f413f05a85358590fd0.svg";